var React = require('react');

function ArrowR (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"25.5","cy":"25.5","r":"25.5","fill":"#2E3BA7","key":0}),React.createElement("path",{"d":"M32.7 26.7L23.7 35.7C23.3 36.1 22.7 36.1 22.3 35.7C21.9 35.3 21.9 34.7 22.3 34.3L30.6 26L22.3 17.7C21.9 17.3 21.9 16.7 22.3 16.3C22.7 15.9 23.3 15.9 23.7 16.3L32.7 25.3C33.1 25.7 33.1 26.3 32.7 26.7Z","fill":"white","key":1})]);
}

ArrowR.defaultProps = {"width":"51","height":"51","viewBox":"0 0 51 51","fill":"none"};

module.exports = ArrowR;

ArrowR.default = ArrowR;
